// DSS Documentation on Validation - http://tiny.sc/cgvalidation
export class ModelError {
  fieldName: string;
  errorMessage: string;
}
